export function auth() {
    let toggleButtons = document.querySelectorAll('[data-authPanelBtn]');
    let panels = document.querySelectorAll('[data-authPanel]');

    function closePanels() {
        panels.forEach(panel => {
            panel.classList.remove('_active');
        })
    }

    function togglePanel(panelTarget) {
        closePanels();
        let panel = document.querySelector(`[data-authPanel=${panelTarget}]`);
        panel.classList.add('_active');
    }

    toggleButtons.forEach(btn => {
        let panelTarget = btn.getAttribute('data-authPanelBtn');
        btn.addEventListener('click', evt => togglePanel(panelTarget));
    })
}
